import { LAYOUT } from '@admin/router/constant'

// plm基础配置
const plmBasicConfigurationRouter = {
  path: '/plmBasicConfiguration',
  name: '',
  component: LAYOUT,
  children: [
    {
      path: '/plm-basic-configuration/unit',
      name: 'Unit',
      component: () => import('@admin/views/plm/plmBasicConfiguration/unit/index.vue'),
      meta: { helpUrl: '', title: '单位' },
    },
    {
      path: '/plm-basic-configuration/color-configuration',
      name: 'plmBasicConfiguration',
      component: () =>
        import('@admin/views/plm/plmBasicConfiguration/colorConfiguration/index.vue'),
      meta: { helpUrl: '', title: '深衣颜色' },
    },
    {
      path: '/plm-basic-configuration/sizing-information',
      name: 'sizingInformation',
      component: () => import('@admin/views/plm/plmBasicConfiguration/sizingInformation/index.vue'),
      meta: { helpUrl: '', title: '尺码信息' },
    },
    {
      path: '/plm-basic-configuration/commodity-design-attribute',
      name: 'commodityDesignAttribute',
      component: () =>
        import('@admin/views/plm/plmBasicConfiguration/commodityDesignAttribute/index.vue'),
      meta: { helpUrl: '', title: '商品设计属性' },
    },
    {
      path: '/plm-basic-configuration/product-processing-technology',
      name: 'productProcessingTechnology',
      component: () =>
        import('@admin/views/plm/plmBasicConfiguration/productProcessingTechnology/index.vue'),
      meta: { helpUrl: '', title: '特殊二次工艺' },
    },
    {
      path: '/plm-basic-configuration/material-processing-technology',
      name: 'materialProcessingTechnology',
      component: () =>
        import('@admin/views/plm/plmBasicConfiguration/materialProcessingTechnology/index.vue'),
      meta: { helpUrl: '', title: '物料加工工艺' },
    },
    {
      path: '/plm-basic-configuration/part-type',
      name: 'partType',
      component: () => import('@admin/views/plm/plmBasicConfiguration/partType/index.vue'),
      meta: { helpUrl: '', title: '部位类型' },
    },
    {
      path: '/plm-basic-configuration/measurement-file',
      name: 'measurementFile',
      component: () =>
        import('@admin/views/plm/plmBasicConfiguration/measurementFile/index/index.vue'),
      meta: { helpUrl: '', title: '度量档案' },
    },
    {
      path: '/plm-basic-configuration/measurement-file-detail',
      name: 'measurementFileDetail',
      component: () =>
        import('@admin/views/plm/plmBasicConfiguration/measurementFile/detail/index.vue'),
      meta: { helpUrl: '', title: '度量档案详情' },
    },
    {
      path: '/plm-basic-configuration/pricing-process-library',
      name: 'pricingProcessLibrary',
      component: () =>
        import('@admin/views/plm/plmBasicConfiguration/pricingProcessLibrary/index.vue'),
      meta: { helpUrl: '', title: '核价工序库' },
    },
    {
      path: '/plm-basic-configuration/process-archives',
      name: 'processArchives',
      component: () => import('@admin/views/plm/plmBasicConfiguration/processArchives/index.vue'),
      meta: { helpUrl: '', title: '工艺档案' },
    },
    {
      path: '/plm-basic-configuration/development-classification-issues',
      name: 'developmentClassificationIssues',
      component: () =>
        import('@admin/views/plm/plmBasicConfiguration/developmentClassificationIssues/index.vue'),
      meta: { helpUrl: '', title: '开发问题分类' },
    },
  ],
}

export default plmBasicConfigurationRouter
